import { render, staticRenderFns } from "./FieldsetFieldtype.vue?vue&type=template&id=0187398e&"
import script from "./FieldsetFieldtype.vue?vue&type=script&lang=js&"
export * from "./FieldsetFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports